export const PRIVILEGE = {
  systemAdministrator: 1,
}

export const FIELD_ID = {
  user: {
    email: 195,
  },
  documentType: {
    name: 101,
    parentDocumentType: 102,
    databaseTableName: 103,
    active: 104,
    fields: 105,
    forms: 106,
    actions: 107,
    descriptiveField: 147,
    includeInMostRecent: 148,
    systemType: 180,
    referenceType: 181,
    abstractType: 182,
    pkColumnName: 190,
    states: 603,
    stateful: 604,
    requiresWorkspace: 613,
    notificationTemplate: 615,
    field: {
      name: 116,
      type: 117,
      databaseColumnName: 118,
      width: 120,
      height: 121,
      maxLength: 122,
      choiceType: 123,
      choiceTableName: 124,
      choiceValue: 125,
      defaultType: 126,
      defaultText: 127,
      largeChoice: 128,
      formatType: 138,
      formatText: 139,
      inFilterType: 140,
      inFilterText: 141,
      outFilterType: 142,
      outFilterText: 143,
      choiceDisplayColumnName: 172,
      choiceMultiTableName: 173,
      dataStoreHook: 175,
      choicePkColumnName: 191,
      referenceTo: 608,
      largeChoiceHook: 612,
    },
    form: {
      tabs: 109,
      submit: 110,
      record: 111,
      reference: 112,
    },
    tab: {
      tabFields: 115,
    },
    tabField: {
      field: 160,
    }
  },
  queryDetail: {
    line: 185,
    field: 170,
    show: 177,
    sortOrder: 179,
    filter: 183,
    prompt: 184,
    notOperator: 187,
    operator: 188,
    filterValue: 189,
  },
  query: {
    name: 167,
    documentType: 168,
    details: 169,
    batchAction: 620,
  }
}

export const CARD_ITEM_TYPE = {
  queryResult: 1111,
  query: 2222,
  newDocument: 3333,
  hyperlink: 4444,
}

export const SEARCH_OPERATOR = {
  equals: 1,
  contains: 2,
  isNull: 3,
  on: 4,
  before: 5,
  after: 6,
  between: 7,
  lessThan: 8,
  greaterThan: 9,
  isIn: 10,
}

export const FIELD_TYPE = {
  shortText: 1,
  // reference: 2,
  referenceList: 3,
  yesNo: 4,
  multilineText: 5,
  integer: 6,
  date: 7,
  currency: 8,
  image: 9, // used in FWCONTRACS only
  staticText: 10,
  // objectHistory: 11,
  // attachements: 12,
  objectState: 13,
  objectId: 14,
  // ldapLookup: 15,
  // parentRef: 16,
  // calculation: 17,
  time: 18,
  multiSelect: 19,
  journal: 20,
  select: 21,
  filterValue: 22,
  file: 23,
  objectOwner: 24,
  hyperlink: 25,
  objectType: 26,
  number: 27,
  requiresWidth: [1, 3, 5, 6, 8, 9, 19, 27],
  requiresHeight: [3, 5, 9, 19],
  requiresMaxLength: [1, 5],
  readOnly: [10, 13, 14, 24],
  isForeignKey: [13, 24, 26]
}

export const ACTION_TYPE = {
  submit: 1,
  changeState: 2,
  modify: 3,
  delete: 4,
}

export const BEHAVIOR_TYPE = {
  readOnly: 1,
  required: 2,
  optional: 3,
  useHook: 4,
}

export const CHOICE_TYPE = {
  constant: 1,
  sql: 2,
  useHook: 3,
  foreignKey: 4,
}

export const FORMAT_TYPE = {
  constant: 1,
  sql: 2,
  useHook: 3
}

export const CONFIG_KEYS = {
  appEntryPoint: {
    key: 'APPLICATION ENTRY POINT',
    defaultValue: 'GUI.HOME',
  },
  maxFileSize: {
    key: 'MAX FILE SIZE',
    defaultValue: '10',
  },
  loginTitleText: {
    key: 'LOGIN TITLE TEXT',
    defaultValue: 'Sign In To Xerdict',
  },
  loginImageSource: {
    key: 'LOGIN IMAGE SRC',
    defaultValue: '/images/xerdict.jpg'
  },
  title: {
    key: 'TITLE',
    defaultValue: 'No TITLE config value'
  },
  loginFooterText: {
    key: 'LOGIN FOOTER TEXT',
    defaultValue: 'a Tanenbaum Keale LLP company'
  },
  loginMessage: {
    key: 'LOGIN MESSAGE',
    defaultValue: null
  },
  showSignUpLink: {
    key: 'SHOW SIGN UP LINK',
    defaultValue: null
  },
}

export const OBJECT_VIEW_STYLE = {
  card: 'Multi Tab Display',
  tab: 'Single Tab Display'
}

export const ATTRIBUTE_NAME = {
  tabStyle: 'TAB STYLE',
  showCreateMenu: 'SHOW CREATE MENU',
  hideInactiveSchemas: 'HIDE INACTIVE SCHEMAS',
  collapseSidebar: 'COLLAPSE SIDEBAR',
  mfaMethod: 'MFA METHOD',
  showObjectId: 'SHOW OBJECT ID'
}
